export const imports = {
  'docs/components-api.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-api" */ 'docs/components-api.mdx'
    ),
  'docs/custom-style.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-custom-style" */ 'docs/custom-style.mdx'
    ),
  'docs/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-index" */ 'docs/index.mdx'
    ),
  'docs/pagination.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pagination" */ 'docs/pagination.mdx'
    ),
  'docs/TableColumnEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-table-column-editor" */ 'docs/TableColumnEditor.mdx'
    ),
  'docs/validate.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-validate" */ 'docs/validate.mdx'
    ),
  'docs/pagination-show-docs/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pagination-show-docs-index" */ 'docs/pagination-show-docs/index.mdx'
    ),
  'docs/pagination-show-docs/pagination-show-demo.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pagination-show-docs-pagination-show-demo" */ 'docs/pagination-show-docs/pagination-show-demo.mdx'
    ),
  'docs/pagination-show-docs/pagination-show-crud.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pagination-show-docs-pagination-show-crud" */ 'docs/pagination-show-docs/pagination-show-crud.mdx'
    ),
  'docs/pagination-show-docs/pagination-show-load-and-view.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pagination-show-docs-pagination-show-load-and-view" */ 'docs/pagination-show-docs/pagination-show-load-and-view.mdx'
    ),
  'docs/pagination-show-docs/pagination-show-query.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pagination-show-docs-pagination-show-query" */ 'docs/pagination-show-docs/pagination-show-query.mdx'
    ),
  'docs/pagination-show-docs/pagination-show-verify.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pagination-show-docs-pagination-show-verify" */ 'docs/pagination-show-docs/pagination-show-verify.mdx'
    ),
  'docs/pagination-show-docs/pagination-show-select.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pagination-show-docs-pagination-show-select" */ 'docs/pagination-show-docs/pagination-show-select.mdx'
    ),
}
